export const DEFAULT_CUSTOM_STUDENT_APP_AMOUNT = 1;
export const DEFAULT_STUDENT_APP_AMOUNT = 20;
export const FIXED_STUDENT_APPS = [20, 40, 60];